import { ListCluster,CreateCluster,ClusterEdit } from './cluster';
import AddCluster from './addcluster';
import DetailCluster from './detailcluster';
// import EditCluster from './editcluster';


export default {
    list: ListCluster,
    create:CreateCluster,
    addcluster: AddCluster,
    showCluster:DetailCluster,
    //  editcluster:EditCluster,
    edit:ClusterEdit,
    
};